import { Deserializable } from '../protocols/deserializable';

export class TransferInTransferRecord implements Deserializable {
  public expectedAmount!: number | null;
  public accountNumber!: string | null;
  public institutionName!: string | null;

  public onDeserialize(): void {}

  public hasEmptyFields(): boolean {
    return (this.expectedAmount ?? null) === null || !this.accountNumber || !this.institutionName;
  }
}
